<div class="card">
  <div class="card-header">
    <h3>{{ name }}</h3>
    <span class="badge status-badge" [class.ok]="status === 'OK'" [class.error]="status === 'ERROR'">
      {{ status }}
    </span>
  </div>

  <div class="card-body">
    <ng-container *ngIf="status === 'LOADING'; else statusContent">
      <p class="loading-text">Loading...</p>
    </ng-container>

    <ng-template #statusContent>
      <ng-container *ngIf="status === 'OK'; else errorContent">
        <div *ngIf="dependencies.length > 0">
          <ul class="dependency-list">
            <li *ngFor="let dependency of dependencies" class="dependency-item">
              <span class="dependency-name">{{ dependency.name }}</span>
              <span
                class="badge dependency-badge"
                [class.up]="dependency.status === 'UP'"
                [class.down]="dependency.status === 'DOWN'">
                {{ dependency.status }}
              </span>
            </li>
          </ul>
        </div>
        <div *ngIf="dependencies.length === 0">
          <p>No dependencies found</p>
        </div>
      </ng-container>

      <ng-template #errorContent>
        <p class="error-text">The service is currently unavailable</p>
      </ng-template>
    </ng-template>
  </div>

  <div class="card-footer">
    <p class="description">{{ description }}</p>
  </div>
</div>
